export default {
    //url:'http://test.tsied.com/api/v1',
    //'http://202.120.35.193/api/v1',
    url: process.env.VUE_APP_API_ROOT?process.env.VUE_APP_API_ROOT:window.location.origin+'/api/v1',
    modules: {
        SignIn: '/user/login',
        SUFEDJTLOGIN:'/user/sufe/djt-login', //大讲堂登录
        SignInSufeWechat:'/user/sufe/wechat',
        SSO: '/user/sso',
        OAuth: '/user/sjtu-oauth',
        ResetPassword: '/user/reset-password',
        Profile: '/user/profile',
        Questionnaire:{},
        Wechat:{
            QYWeb:'/user/wx/corp-web',
            QY:'/user/wx/corp',
        },
        Query: {
            Busy: '/query/busy',
            Emails: '/query/emails',
            Host: '/query/host',
            View:{
                Day:'/query/view/day',
                Week:'/query/view/week',
                Month:'/query/view/month'
            },
            Meeting:{
                Search:'/query/meeting/search'
            },
            Rebuild:{
                Attendee: "/query/rebuild/attendee"
            }
        },
        User: {
            Get: '/user/get',
            Remind: '/user/remind',
            Preset: '/user/preset',
            Incomplete:'/user/incomplete',
            SaveAddress:'/user/save-address',
            UploadImage:'/user/upload-image',
            Calendar:{},
            Recurrent:{}
        },
        Announcement: {
          Newest:'/announcement/newest'
        },
        Admin: {
            DepartmentPrivilege:{},
            Disclaimer:{},
            RoomGroup:{},
            Contact:{},
            Group:{},
            Yellow:{},
            Poll: {},
            Meeting: {
                Create: '/admin/meeting/create',
                Import: '/admin/meeting/import',
            },
            Approve: {
                List: '/admin/approve/list',
                Approve: '/admin/approve/approve',
                Get: '/admin/approve/get',
            },
            Parameter: {},
            ZoomRoom: {},
            Visitor: {
                All: {
                    UserId: '/admin/visitor/all/uid',
                }
            },
            User: {
                Approve: {
                    List: '/admin/user-approve/list',
                    Get: '/admin/user-approve/get',
                    Approve: '/admin/user-approve/approve'
                }
            },
            Asset:{},
            Syslog:{},
            MailTemplate:{},
            PositionCode:{},
            Survey:{},
            Announcement:{
                newest:'/announcement/newest'
            },
            University:{},
            Delay:{}
        },
        Meeting: {
            List: '/meeting/list',
            Delete: '/meeting/delete',
            Edit: '/meeting/edit',
            Get: '/meeting/get',
            Host: '/meeting/host',
            Mail: {
                Attendee: '/meeting/mail/attendee',
                Host: '/meeting/mail/host',
            },
        },
        Report: {
            Statistic: {
                Get: '/report/statistic/get',
                Download: '/report/statistic/download',
            },
            Survey:{
                Get: '/report/survey/get',
                Download: '/report/survey/download',
            },
            Meeting:{
                Detail:{
                    List:'/report/meeting/detail/list',
                    Transcription:'/report/meeting/detail/transcription',
                },
                Lock:{
                    List:'/report/meeting/lock/list',
                }
            }
        }
    }
}
